import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { createStyles, IconButton, makeStyles } from "@material-ui/core";
import { useLiveChatConfig } from "../../../NavProvider";
import { clickOnChatLink, closeChatBubble, openChatBubble } from "../../analytics";
import CloseIcon from "../../../../../icons/Close";
var useStyles = makeStyles(function (_a) {
    var _b;
    var breakpoints = _a.breakpoints;
    return createStyles({
        root: (_b = {
                position: "absolute",
                bottom: 0,
                right: "calc(100% + 16px)",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                width: "calc(100vw - 6rem)",
                padding: 16,
                backgroundColor: "#e1fec6",
                borderRadius: "4px",
                borderBottomRightRadius: 0,
                outline: "none",
                filter: "drop-shadow(0 1px 3px rgba(0, 0, 0, 0.4))",
                opacity: 0,
                transform: "scale(0)",
                transformOrigin: "bottom right",
                transition: "opacity 150ms ease, transform 150ms ease"
            },
            _b[breakpoints.up("sm")] = {
                width: 272,
            },
            _b["&:hover"] = {
                backgroundColor: "#e1fec6",
            },
            _b),
        showBubble: {
            opacity: 1,
            transform: "scale(1)",
        },
        text: {
            display: "flex",
            flexDirection: "column",
            color: "#333",
            fontSize: 16,
            pointerEvents: "all",
            textDecoration: "none",
            "&:focus": {
                outline: "none",
            },
        },
        title: {
            fontSize: 16,
            fontWeight: "bold",
            marginBottom: 4,
        },
        close: {
            marginTop: -12,
        },
        tail: {
            position: "absolute",
            bottom: 0,
            right: -8,
            width: 8,
            height: 13,
            fill: "#e1fec6",
        },
    });
});
var ChatBubble = function (_a) {
    var whatsAppUrl = _a.whatsAppUrl, show = _a.show;
    var _b = useLiveChatConfig(), bubbleTitle = _b.bubbleTitle, bubbleDesc = _b.bubbleDesc;
    var styles = useStyles();
    var _c = useState(false), hasClosed = _c[0], setHasClosed = _c[1];
    var _d = useState(false), showBubble = _d[0], setShowBubble = _d[1];
    var handleClose = function (event) {
        event.preventDefault();
        event.stopPropagation();
        requestAnimationFrame(function () {
            setHasClosed(true);
            setShowBubble(false);
            closeChatBubble();
        });
    };
    useEffect(function () {
        if (show && !hasClosed)
            requestAnimationFrame(function () {
                setShowBubble(true);
                openChatBubble();
            });
    }, [show, hasClosed]);
    return (React.createElement("a", { id: "acm-livechat__bubble", className: clsx(styles.root, showBubble && styles.showBubble), href: whatsAppUrl, target: "_blank", rel: "noopener noreferrer", onClick: function () { return clickOnChatLink(whatsAppUrl); } },
        React.createElement("div", { className: styles.text },
            React.createElement("span", { className: styles.title }, bubbleTitle),
            React.createElement("span", null, bubbleDesc)),
        React.createElement(IconButton, { id: "acm-livechat__close-bubble", classes: { root: styles.close }, edge: "end", onClick: handleClose },
            React.createElement(CloseIcon, { color: "#333" })),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: styles.tail },
            React.createElement("path", { d: "M0 0v13h7.006c.919 0 1.344-1.522.649-2.325z" }))));
};
export default ChatBubble;
